export const stat = {
  table: {
    field: {
      src: 'Исходящий',
      dst: 'Входящий',
      date: 'Дата',
      time: 'Время',
      duration: 'Длительность',
      type_answer: 'Статус',
      sip_account: 'SIP-аккаунт',
      contact: 'Контакт',
      recording: 'Запись'
    }
  },

  common: {
    field: {
      date: 'Дата',
      external: 'Внешние',
      internal: 'Внутренние',
      incoming: 'Входящие',
      outgoing: 'Исходящие',
      total: 'Всего',
      acd: 'ACD',
      asr: 'ASR'
    },

    block: {
      main: 'Звонки',
      asr: 'ASR',
      acd: 'ACD'
    },

    filter: {
      group_by: {
        title: 'Группировать по',
        values: {
          date: 'Дата',
          contact: 'Контакт',
          sip_account: 'SIP-аккаунт',
          destination: 'Направление',
          type: 'Тип'
        }
      }
    }
  },

  detailed: {
    field: {
      type: 'Тип',
      destination: 'Направление'
    }
  },

  call_type: {
    incoming: 'Входящий',
    outgoing: 'Исходящий'
  },

  call_destination: {
    internal: 'Внутренний',
    external: 'Внешний'
  },

  type_answer: {
    ANSWERED: 'Отвечено',
    FAILED: 'Ошибка',
    CANCELED: 'Отменено',
    REJECTED: 'Отклонено',
    NO_ANSWER: 'Без ответа'
  },

  contact_not_fixed: 'Контакт не\u00A0зафиксирован',
  sip_not_fixed: 'SIP-аккаунт не\u00A0зафиксирован',

  errors: {
    date: 'Неверный период даты',
    date_period: 'Заданный период не должен превышать 7 дней'
  },

  tooltips: {
    period: 'Заданный период не должен превышать 7 дней',
    one_sip_account: 'Отображается первый зафиксированный SIP-аккаунт',
    sip_not_fixed: 'Это могут быть звонки на точку входа в схеме маршрутизации АТС или иные ситуации, в которых зафиксировать аккаунт оператора не удалось'
  }
};
